// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Download extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone download</title>
        <desc>Ícone de uma seta para baixo</desc>
        <g id="icon-download">
          <path d="M9,8.56l3.29-3.27a1,1,0,0,1,1.42,0h0a1,1,0,0,1,0,1.42l-5,5a1,1,0,0,1-1.42,0l-5-5a1,1,0,0,1,0-1.42h0a1,1,0,0,1,1.42,0L7,8.56V1A1,1,0,0,1,8,0H8A1,1,0,0,1,9,1ZM16,15h0a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1H0a1,1,0,0,0,1,1H15A1,1,0,0,0,16,15Z" />
        </g>
      </svg>
    );
  }
}

export default Download;
